/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id" endpoint
 */
import {
  engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdSteps,
  getCanvasVersionStepsChunked,
} from "@dashboardApi/apis/canvas/canvasVersionSteps";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import type { CanvasResult } from "../common";
import { engagementAppGroupIdCanvasWorkflowIdVersionsVersionId } from "./constants";

/**
 * @note this composes multiple fetchers to make thinking about using this in a hook a
 *   lot simpler.
 */
export const getCanvasVersion = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasWorkflowIdVersionsVersionId,
  async (signal: AbortSignal, appGroupId: string, canvasId: string, versionId: string): Promise<CanvasResult> => {
    const result = await fetch<CanvasResult>(
      `/engagement/${appGroupId}/canvas/${canvasId}/versions/${versionId}`,
      "GET",
      {},
      {
        signal,
      }
    );

    const {
      workflow: { step_ids },
    } = result;

    result.workflow.steps = await getCanvasVersionStepsChunked({
      queryKey: [
        {
          cacheKey: engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdSteps,
        },
        appGroupId,
        canvasId,
        versionId,
        // eslint-disable-next-line camelcase
        step_ids,
      ],
      signal,
    });

    result.workflow.version_id = versionId;

    return result;
  }
);
